  export default function removeP(value) {	
    let text = value;

    if(text != ''){
        text = text.replaceAll('<p>', '');
        text = text.replaceAll('</p>', '');
    }

    return text;
}